import PropTypes from 'prop-types';
import React from 'react';
import NoSSR from 'react-no-ssr';
import moment from 'moment-timezone';
import FGBLabel from '../../Elements/FGBLabel/FGBLabel';
import { eventPropTypesShape } from '../../Includes/eventsProps';
import { getMonthByNumber } from '../../Utilities/TimeFunctions';
import EventRegisterButtonContainer from '../EventRegisterButton/EventRegisterButtonContainer';

import './SingleEventPageBottomCard.scss';

const SingleEventPageBottomCard = (props) => {
    const { isUserRegistered, setUserAsRegistered, event } = props;
    const startDateUTC = new Date(moment.tz(event.startTime, 'UTC'));
    const momentStartTime = moment(startDateUTC).tz('America/New_York');
    const momentEndTime = moment(new Date(moment.tz(event.endTime, 'UTC'))).tz(
        'America/New_York'
    );
    const startTimeFormatted = momentStartTime.format('h:mma');
    const endTimeFormatted = momentEndTime.format('h:mma');
    const month = getMonthByNumber(momentStartTime.format('M'));
    const day = momentStartTime.format('D');
    const dayOfWeek = momentStartTime.format('dddd');
    const year = momentStartTime.format('YYYY');

    return (
        <div className="component-Events-SingleEventPageBottomCard">
            <FGBLabel>{props.event.eventType}</FGBLabel>
            <div className="bottom-card-title-section">{props.event.title}</div>
            <NoSSR>
                <div className="bottom-section-date-display">
                    {`${dayOfWeek} ${month} ${day}, ${year} | ${startTimeFormatted} - ${endTimeFormatted} ET`}
                </div>
            </NoSSR>
            <div className="single-event-bottom-card-button-div">
                <EventRegisterButtonContainer
                    event={event}
                    isUserRegistered={isUserRegistered}
                    setUserAsRegistered={setUserAsRegistered}
                    isSingleEventPage
                />
            </div>
        </div>
    );
};

SingleEventPageBottomCard.propTypes = {
    /**
     * single event data
     */
    event: eventPropTypesShape.isRequired,
    /**
     * whether user is register for the event or not
     */
    isUserRegistered: PropTypes.bool.isRequired,
    /**
     * set userRegistered to true
     */
    setUserAsRegistered: PropTypes.func.isRequired,
};

export default SingleEventPageBottomCard;
